import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export interface Provider {
    id: string;
    description: {
        de: string;
        en: string;
    };
    callbackUrls: CallbackUrl[];
}

export interface CallbackUrl {
    id: string;
    url: string;
}

export const CampusIdInit = createAction('[campusID] Initialize Campus Id');
export const CampusIdStore = createAction('[campusID] Store secret key', props<{ secret: string; uuid: string }>());
export const CampusIdFailed = createAction('[campusID] Initialization failed', props<{ error: HttpErrorResponse }>());

export const CampusIdFetchProvider = createAction('[campusID] Fetch provider list');
export const CampusIdUpdateProvider = createAction('[campusID] Update provider list', props<{ provider: Provider[] }>());

export const CampusIdValidate = createAction('[campusID] Validate secret', props<{ uuid: string; totp: string }>());
export const CampusIdValidateFailed = createAction('[campusID] Validate failed', props<{ error: HttpErrorResponse }>());
export const CampusIdInvalidate = createAction('[campusID] Invalidate secret');
export const CampusIdValid = createAction('[campusID] Secret verified');

export const CampusIdReset = createAction('[campusID] Reset Campus Id');
